import PropTypes from 'prop-types';
import { UserConsumer } from '../../core/providers/UserProvider';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import ActionText from '../../core/ActionText';
import { ENTITLEMENTS as APPENTITLEMENTS } from '../../core/utils/constants';
import Errored from '../../core/Errored';
import Loading from '../../core/Loading';
import { globalStyles as styles } from '../../core/style/gstheme';
import { makeCancelable } from '../../core/utils/utils';
import GS from '../../grafsync/grafsync';
import CreateGroupDialogContainer from './CreateGroupDialogContainer';
import GroupDetail from './GroupDetail';
import GroupStructure from './GroupStructure';

class GroupsManager extends Component {

  constructor(props) {
    super(props);
    this.state = {
      updateAt: null,
      selectedGroup: null,
      deletedGroups: [],
      altered: false,
      isLoadingEntitlements: true,
      isErrored: null
    };
    this.cancellable = null;
  }

  componentDidMount() {
    this.doSearch({
      search: [{
        predicate: "https://graphifi.com/schema/accesscontrol/inSecurityScheme",
        value: [
          "https://grafsync.graphifi.com/schema/vm-entitlement/",
          "https://grafsync.graphifi.com/schema/om-entitlement/",
          "https://graphifi.com/schema/entitlement/"]
      }],
      graph: [GS.getActiveSubscription()],
      page: 1,
      noCount: true,
      pageSize: 200
    })
      .promise
      .then(data => {
        const ents = data.results || null;
        this.setState({ entitlements: ents, isLoadingEntitlements: false });
      })
      .catch((e) => {
        if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
      });
  }

  doSearch(payload) {
    this.cancellable = makeCancelable(GS.search(payload));
    return this.cancellable;
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
  }

  createGroup = (id) => {
    this.setState({ selectedGroup: id, altered: true });
  };

  selectGroup = (id) => {
    if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ selectedGroup: id, altered: false });
  };

  onUpdate = () => {
    if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ altered: false });
  };

  deleteGroup = (iri) => {
    const deletedGroupList = [...this.state.deletedGroups];
    deletedGroupList.push(iri);
    GS.deleteResource(iri, GS.getActiveSubscription());
    this.selectGroup(null);
    if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ updateAt: Date.now(), deletedGroups: deletedGroupList });
  };

  render() {

    const { classes } = this.props;
    const { isLoadingEntitlements, groups, altered,
      selectedGroup, deletedGroups, entitlements, isErrored, updateAt } = this.state;

    if (isErrored) return <Errored data={isErrored} />;
    if (isLoadingEntitlements) return <Loading />;

    return (
      <UserConsumer>
        {({ entitlements: appEntitlements }) => {
          return <div>
            <GroupStructure
              onUpdate={this.onUpdate}
              groups={groups}
              altered={altered}
              selectedGroup={selectedGroup}
              refreshAt={updateAt}
              deletedGroups={deletedGroups}
              onSelectGroup={this.selectGroup} />
            <div className={classes.dashboardPanel}>
              {appEntitlements.includes(APPENTITLEMENTS.CREATE_GROUP) &&
                <div className={classes.dashboardAdd}>
                  <CreateGroupDialogContainer onCreateGroup={this.createGroup} />
                </div>
              }
              {!appEntitlements.includes(APPENTITLEMENTS.VIEW_ENTITLEMENT) ?
                <ActionText offset="130px">You do not have permissions to view entitlements.</ActionText>
                :
                selectedGroup ?
                  <GroupDetail
                    key={selectedGroup}
                    graph={GS.getActiveSubscription()}
                    id={selectedGroup}
                    entitlements={entitlements}
                    onDeleteGroup={this.deleteGroup} />
                  :
                  <ActionText offset="180px">Select a group to view and edit its detail.</ActionText>
              }
            </div>
          </div>;
        }}
      </UserConsumer>
    );
  }
}

GroupsManager.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(GroupsManager);